import { getConfig } from 'src/configs'

const config = getConfig()

export default {
  state: () => ({
    gamesByManufacturer: null,
    gameObject: null,
    gameObjectLoaded: false,
  }),
  mutations: {
    UPDATE_GAME_OBJECT(state, value) {
      if (value) {
        state.gameObject = { ...value, game: { ...value.game } }
      } else {
        state.gameObject = null
      }
    },
    UPDATE_GAME_OBJECT_IS_FAVORITE(state, value) {
      if (!state.gameObject) {
        return
      }
      state.gameObject.game.isFavorite = value
    },
    UPDATE_GAME_OBJECT_LOADED(state, value) {
      state.gameObjectLoaded = value
    },
  },
  getters: {
    getGameObject: (s) => s.gameObject,
    getGameObjectData: (s) => s.gameObject?.game ?? null,
    gameObjectLoaded: (s) => s.gameObjectLoaded,
    showSport: () => config.sportsBook,
  },
}
